import type { AutoWorkflowPlan, AutoWorkflowStatus } from '@sr-test-wizard/shared';
import { api } from './api';

export interface AutoWorkflowStatusResponse extends AutoWorkflowStatus {
  preconditionsReady: boolean;
  preconditionsReason: string | null;
}

export const autoWorkflowApi = {
  status: (runId: string) =>
    api.get<AutoWorkflowStatusResponse>(`/api/runs/${runId}/auto-workflow`),
  start: (runId: string, plan: AutoWorkflowPlan) =>
    api.post<AutoWorkflowStatus>(`/api/runs/${runId}/auto-workflow`, plan),
  stop: (runId: string) =>
    api.post<{ stopping: boolean }>(`/api/runs/${runId}/auto-workflow/stop`),
};
